import { displayCurrentLevel } from './membership-level-groups';
import { AmountSelection } from '../../modules/amount-selection';
// Custom amount checkbox used by multiple things
export const customAmountInput = document.querySelector('#Amounts_custom-field') as HTMLInputElement;
export const customAmountRadio = document.querySelector('#Amounts_custom') as HTMLInputElement;
export const donationAmountRadios = document.querySelectorAll('#Donation_amounts input[type="radio"]') as NodeListOf<HTMLInputElement>;
export const invalidAmountError = document.querySelector('[data-amount-invalid-error]') as HTMLElement;

export const initializeAmounts = () => {
    if (donationAmountRadios) {
        donationAmountRadios.forEach((radio) => {
            radio.addEventListener('click', () => {
                invalidAmountError.setAttribute('hidden', '');
                customAmountInput.value = "";
            });
        });
    }

    if (customAmountInput) {
        customAmountInput.addEventListener('blur', () => {
            customAmountRadio.checked = true;
            const newValue = parseInt(customAmountInput.value);
            if (isNaN(newValue) || newValue < 0) {
                customAmountInput.value = '0';
                invalidAmountError.removeAttribute('hidden');
            }
            else {
                invalidAmountError.setAttribute('hidden', '');
            }
            displayCurrentLevel(newValue);
        });

        const donationAmountsList = document.querySelector('#Donation_amounts');
        if (donationAmountsList) {
            const allRadios = [].slice.call(donationAmountsList.querySelectorAll('input[type="radio"]'));
            const customAmountRadio = document.querySelector('#Amounts_custom') as HTMLInputElement;
            new AmountSelection(customAmountInput, allRadios, customAmountRadio);
        }
    }
}